// Utility functions to get translated options

export const getGenderOptions = (t) => [
  { label: t("male"), value: 1 },
  { label: t("female"), value: 2 },
];

export const getExtraQuestionOptions = (t) => [
  { label: t("yes"), value: 1 },
  { label: t("no"), value: 2 },
];

export const getInformationSourceOptions = (t) => [
  { label: t("from_friend"), value: 1 },
  { label: t("from_tia_employee"), value: 2 },
  { label: t("from_newspaper"), value: 3 },
  { label: t("from_internet"), value: 4 },
];


export const getComputerProgramOptions = (t) => [
  { value: 0, label: t("ms_office") }, 
  { value: 1, label: t("customer_service") }, 
  { value: 2, label: t("team_work") }, 
  { value: 3, label: t("communication_skills") }, 
  { value: 4, label: t("problem_solving") }, 
  { value: 5, label: t("leadership") }, 
  { value: 6, label: t("airport_systems") }, 
];


export const getLanguageLevelOptions = (t) => [
  { label: t("basic"), value: "Basic" },
  { label: t("intermediate"), value: "Intermediate" },
  { label: t("fluent"), value: "Fluent" },
  { label: t("native"), value: "Native" },
];

export const getWorkTimeOptions = (t) => [
  { label: t("full_time"), value: 1 },
  { label: t("seasonal"), value: 2 },
  { label: t("internship"), value: 3 },
];

export const getAvailabilityOptions = (t) => [
  { label: t("full_time"), value: 1 },
  { label: t("seasonal"), value: 2 },
  { label: t("internship"), value: 3 },
];

export const getNationalityOptions = (t) => [
  { value: t("shqiptar"), label: t("shqiptar") },
  { value: t("italian"), label: t("italian") },
  { value: t("grek"), label: t("grek") },
  { value: t("turk"), label: t("turk") },
  { value: t("gjerman"), label: t("gjerman") },
  { value: t("francez"), label: t("francez") },
  { value: t("spanjoll"), label: t("spanjoll") },
  { value: t("rus"), label: t("rus") },
  { value: t("kinez"), label: t("kinez") },
  { value: t("japonez"), label: t("japonez") },
  { value: t("amerikan"), label: t("amerikan") },
  { value: t("kanadez"), label: t("kanadez") },
  { value: t("brazilian"), label: t("brazilian") },
  { value: t("arab"), label: t("arab") },
  { value: t("indian"), label: t("indian") },
  { value: t("korean"), label: t("korean") },
  { value: t("suedez"), label: t("suedez") },
  { value: t("norvegjez"), label: t("norvegjez") },
  { value: t("zelandz"), label: t("zelandz") },
];

export const getEducation = (t) => [
  { label: t("entry_level_education"), value: t("entry_level_education") },
  { label: t("middle_level_education"), value: t("middle_level_education") },
  { label: t("vocational_education"), value: t("vocational_education") },
  { label: t("high_level_education"), value: t("high_level_education") },
  { label: t("higher_education_master"), value: t("higher_education_master") },
  { label: t("higher_education_professional"), value: t("higher_education_professional") },
  { label: t("higher_education_phd"), value: t("higher_education_phd") },
];



export const getLanguageOptions = (t) => [
  { value: t("albanian_language"), label: t("albanian_language") },
  { value: t("english_language"), label: t("english_language") },
  { value: t("italian_language"), label: t("italian_language") },
  { value: t("german_language"), label: t("german_language") },
  { value: t("french_language"), label: t("french_language") },
  { value: t("spanish_language"), label: t("spanish_language") },
  { value: t("turkish_language"), label: t("turkish_language") },
  { value: t("greek_language"), label: t("greek_language") },
  { value: t("russian_language"), label: t("russian_language") },
  { value: t("chinese_language"), label: t("chinese_language") },
  { value: t("japanese_language"), label: t("japanese_language") },
  { value: t("arabic_language"), label: t("arabic_language") },
  { value: t("portuguese_language"), label: t("portuguese_language") },
  { value: t("serbian_language"), label: t("serbian_language") },
  { value: t("croatian_language"), label: t("croatian_language") },
  { value: t("bosnian_language"), label: t("bosnian_language") },
  { value: t("macedonian_language"), label: t("macedonian_language") },
  { value: t("romanian_language"), label: t("romanian_language") },
  { value: t("bulgarian_language"), label: t("bulgarian_language") },
  { value: t("polish_language"), label: t("polish_language") }
];


export const getSteps = (t) => [
  t("step_personal"),
  t("step_education"),
  t("step_experience"),
  t("step_languages"),
  t("step_skills"),
  t("step_training"),
  t("step_extra"),
  t("step_cover_letter"),
  t("step_declaration"),
];
